import format from 'date-fns/format';
export function formatDateISO(value) {
    const date = ensureDate(value);
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
}
export function formatDate(value, formatString = 'MMMM do yyyy') {
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return format(date, formatString);
}
export function formatDay(value) {
    const date = ensureDate(value);
    const formatter = new Intl.DateTimeFormat(undefined, {
        day: 'numeric',
        weekday: 'short',
    });
    return formatter.format(date);
}
export function formatRange(from, to) {
    const dateFrom = ensureDate(from);
    const dateTo = ensureDate(to);
    const formatter = new Intl.DateTimeFormat(undefined, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
    return formatter.formatRange(dateFrom, dateTo);
}
export function ensureDate(value) {
    if (typeof value === 'string') {
        return new Date(value.replace('Z', '')); // treat as local time
    }
    return value;
}
export function formatTime(value) {
    const date = ensureDate(value);
    const formatter = new Intl.DateTimeFormat(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });
    return formatter.format(date);
}
export function extractTimeLocal(value) {
    const timePortion = value.split('T')[1] || '';
    return timePortion.substring(0, 5);
}
